import React, { useEffect, useState } from "react";
import { addDays, format } from "date-fns";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ReferenceArea,
  ResponsiveContainer,
  ReferenceLine,
  XAxis,
  Legend,
  YAxis,
  Tooltip,
  Label,
} from "recharts";
import { dataRaw } from "./data2";
import ConfirmationDlg from "../../../../../components/ConfirmationDlg";

const ChartDegradationOverview = ({ assetId, calculateValue = 0, allData }) => {
  const [showModal, setShowModal] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState(null);
  function changeToQuarter(val) {
    let date = new Date(val);
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let quarter = Math.ceil(month / 3);
    return "Q" + quarter + " " + year;
  }

  // useEffect(() => {
  //   console.log({ calculateValue });
  //   if (calculateValue > 0) {
  //     recalculateRandom();
  //   }
  // }, [calculateValue]);

  useEffect(() => {
    const dataFilter = allData.map((item) => {
      return {
        days: item.Year,
        score: item.Year <= "2026" ? item["Smoothed Deterioration"] : null,
        score_2: item.Year >= "2025" ? item["Smoothed Deterioration"] : null,
        maintenance: item.Total_PM_Cost,
        annualize: item["Annualized LCC"],
        ref: item.Year == "2025" ? "C" : item.Ref,
      };
    });
    const finds = dataFilter.find((s) => s.score !== null);
    if (dataFilter.length)
      if (!finds) dataFilter[0].score = dataFilter[0]?.score_2;
    setData(dataFilter);
  }, [allData]);

  const recalculateRandom = () => {
    const array = [
      "ASD-GSE-01CR01-PAC002",
      "ASD-GSE-03CR02-PAC003",
      "LSD-MWB-01WK13-PAC004",
    ];
    let newIndex = currentIndex + 1;
    console.log({ newIndex });
    if (newIndex >= array.length) {
      setCurrentIndex(0);
      newIndex = 0;
    } else {
      setCurrentIndex(newIndex);
    }
    const dataFilter = dataRaw[array[newIndex]];

    const data = dataFilter.map((item) => {
      const { Quarter, ref } = item;
      const score = parseFloat(item["Health Indicator"]);
      const maintenance = parseFloat(item["Total Maintenance Cost"]);
      const ownership = parseFloat(item["Total Cost of Ownership"]);
      const annualize = parseFloat(item["Annualized Cost"]);
      const random = Math.floor(Math.random() * 0.1);
      return {
        days: changeToQuarter(Quarter),
        score: Quarter <= "2025-05-01" ? score : null,
        score_2: Quarter >= "2025-04-01" ? score : null,
        maintenance,
        ownership,
        annualize,
        ref: ref,
      };
    });
    setData(data);
  };

  const [refF, setRefF] = useState(null);
  const [refP, setRefP] = useState(null);

  const [refF2, setRefF2] = useState(null);
  const [refP2, setRefP2] = useState(null);
  const [refC, setRefC] = useState(null);
  useEffect(() => {
    const ref_f = data.filter((i) => i.ref === "F");
    if (ref_f.length === 1) {
      setRefF(ref_f[0]);
      setRefF2(null);
    }

    if (ref_f.length === 2) {
      setRefF(ref_f[0]);
      setRefF2(ref_f[1]);
    }

    const ref_p = data.filter((i) => i.ref === "P");
    if (ref_p.length === 1) {
      setRefP(ref_p[0]);
      setRefP2(null);
    }
    if (ref_p.length === 2) {
      setRefP(ref_p[0]);
      setRefP2(ref_p[1]);
    }
    const ref_c = data.find((i) => i.ref === "C");
    setRefC(ref_c);
  }, [data]);
  const formatTick = (tick) => {
    //convert days to month
    const month = Math.floor(tick / 30);
    return month;
    // return tick.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const formatAddDays = (tick) => {
    return format(new Date(tick), "dd/MM/yyyy");
  };
  const CustomLabelRed = ({ viewBox, value }) => {
    const { x, y } = viewBox;
    return (
      <>
        <circle
          onClick={showDetailPopupAlert}
          cx={x}
          cy={y - 5 * 0.05}
          r={5}
          fill="red"
          cursor={"pointer"}
        />
        <text
          onClick={showDetailPopupAlert}
          x={x}
          y={y - 10}
          fill="red"
          fontSize={13}
          textAnchor="left"
          cursor={"pointer"}
        >
          {value}
        </text>
      </>
    );
  };
  const CustomLabelPurple = ({ viewBox, value }) => {
    const { x, y } = viewBox;
    return (
      <>
        <circle
          onClick={showDetailPopupCritical}
          cx={x}
          cy={y - 5 * 0.05}
          r={5}
          fill="#7067ac"
          cursor={"pointer"}
        />
        <text
          onClick={showDetailPopupCritical}
          x={x}
          y={y - 10}
          fill="#7067ac"
          fontSize={13}
          textAnchor="left"
          cursor={"pointer"}
        >
          {value}
        </text>
      </>
    );
  };
  const CustomLabelGrey = ({ viewBox, value }) => {
    const { x, y } = viewBox;
    return (
      <>
        <circle
          onClick={showCurrentCondition}
          cx={x}
          cy={y - 5 * 0.05}
          r={5}
          fill="white"
          cursor={"pointer"}
        />
        <text
          onClick={showCurrentCondition}
          x={x}
          y={y - 10}
          fill="white"
          fontSize={13}
          textAnchor="left"
          cursor={"pointer"}
        >
          {value}
        </text>
      </>
    );
  };

  const showDetailPopupCritical = () => {
    setShowModal(true);
    setSelected(refF);
  };
  const showDetailPopupAlert = () => {
    setShowModal(true);
    setSelected(refP);
  };
  const showCurrentCondition = () => {
    setShowModal(true);
    setSelected(refC);
  };

  return (
    <ResponsiveContainer height={320}>
      <ConfirmationDlg
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
        onSubmit={() => {
          setShowModal(false);
        }}
        title={"Forecast Cost"}
        hideCancelBtn={true}
        btnSubmitText={"Ok"}
      >
        Forecasted Maintenance Cost : <b>${selected?.maintenance}</b> <br />
        Health Score : <b>{selected?.score}</b> <br />
        Time : <b>${selected?.days}</b>
      </ConfirmationDlg>
      <AreaChart
        data={data}
        margin={{ top: 30, right: 30, left: 10, bottom: 30 }}
      >
        <defs>
          <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
            <stop offset="1%" stopColor="#03408a" />
            <stop offset="99%" stopColor="#065dc8" />
          </linearGradient>
          <linearGradient id="colorUv1" x1="0" y1="0" x2="0" y2="1">
            <stop offset="3%" stopColor="#705138" />
            <stop offset="97%" stopColor="#705138" />
          </linearGradient>
        </defs>
        <XAxis
          type={"category"}
          tick={{ fill: "white" }}
          fontSize={13}
          tickCount={10}
          domain={[0, 4500]}
          dataKey={"days"}
        >
          <Label
            fill={"white"}
            fontSize={13}
            value="Lifespan"
            offset={-20}
            position="insideBottom"
          />
        </XAxis>
        <YAxis tick={{ fill: "white" }} dataKey={"score"} fontSize={13}>
          <Label
            fontSize={13}
            fill={"white"}
            value="Health Indicator"
            angle={-90}
            position="insideBottomLeft"
          />
        </YAxis>
        <Tooltip
          animationEasing={"ease-in-out"}
          content={({ active, label, payload }) => {
            return active ? (
              <div style={{ color: "white" }}>
                {payload.map((row, index) => {
                  return (
                    <div
                      key={index}
                      className={index !== payload.length - 1 ? "mb-1" : ""}
                    >
                      <div
                        style={{
                          color: row.color,
                        }}
                      >
                        Date: {label} <br />
                        Score: {row.value}
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : null;
          }}
          wrapperStyle={{
            background: "rgba(255,255,255,0.8)",
            borderRadius: 4,
            padding: "5px 8px",
            fontWeight: 500,
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          }}
          cursor={false}
        />
        <CartesianGrid
          strokeDasharray="6 1 2"
          horizontal={false}
          strokeOpacity={0.2}
          stroke={"#E73145"}
        />
        {/*<ReferenceLine*/}
        {/*  height={50}*/}
        {/*  x={4000}*/}
        {/*  label={"oke"}*/}
        {/*  stroke={"#E73145"}*/}
        {/*  strokeWidth={2}*/}
        {/*></ReferenceLine>*/}

        <Area
          type="monotone"
          dataKey={"score"}
          stackId="2"
          strokeWidth={2}
          fillOpacity={0.7}
          stroke={"#03408a"}
          fill="url(#colorUv)"
        />
        <Area
          type="monotone"
          dataKey={"score_2"}
          strokeDasharray={"3 4"}
          stackId="1"
          strokeWidth={2}
          fillOpacity={0.7}
          stroke={"#ad550e"}
          fill="url(#colorUv1)"
        />
        {refP ? (
          <>
            <ReferenceLine
              x={refP.days}
              stroke="#E73145"
              strokeDasharray="3 3"
            ></ReferenceLine>
            <ReferenceLine
              y={refP.score}
              stroke="#E73145"
              strokeDasharray="3 3"
            ></ReferenceLine>
            <ReferenceArea
              x1={refP.days}
              x2={refP.days}
              y1={0}
              y2={refP.score || refP.score_2}
              fill="red"
              cursor={"pointer"}
              onClick={showDetailPopupAlert}
              strokeWidth={2}
              fillOpacity={1}
              stroke="#E73145"
              label={<CustomLabelRed value={"Potential Failure (P)"} />}
            ></ReferenceArea>
          </>
        ) : null}
        {refP2 ? (
          <>
            <ReferenceLine
              x={refP2.days}
              stroke="#E73145"
              strokeDasharray="3 3"
            ></ReferenceLine>
            <ReferenceLine
              y={refP2.score}
              stroke="#E73145"
              strokeDasharray="3 3"
            ></ReferenceLine>
            <ReferenceArea
              x1={refP2.days}
              x2={refP2.days}
              y1={0}
              y2={refP2.score || refP2.score_2}
              fill="red"
              cursor={"pointer"}
              onClick={showDetailPopupAlert}
              strokeWidth={2}
              fillOpacity={1}
              stroke="#E73145"
              label={<CustomLabelRed value={"Potential Failure (P)"} />}
            ></ReferenceArea>
          </>
        ) : null}

        {refF ? (
          <>
            <ReferenceLine
              x={refF.days}
              stroke="#7067ac"
              strokeDasharray="3 3"
            ></ReferenceLine>
            <ReferenceLine
              y={refF.score}
              stroke="#7067ac"
              strokeDasharray="3 3"
            ></ReferenceLine>
            <ReferenceArea
              x1={refF.days}
              x2={refF.days}
              y1={0}
              y2={refF.score || refF.score_2}
              fill="red"
              strokeWidth={2}
              fillOpacity={1}
              onClick={showDetailPopupCritical}
              cursor={"pointer"}
              stroke="#7067ac"
              label={<CustomLabelPurple value={"Functional Failure (F)"} />}
            ></ReferenceArea>
          </>
        ) : null}
        {refF2 ? (
          <>
            <ReferenceLine
              x={refF2.days}
              stroke="#7067ac"
              strokeDasharray="3 3"
            ></ReferenceLine>
            <ReferenceLine
              y={refF2.score}
              stroke="#7067ac"
              strokeDasharray="3 3"
            ></ReferenceLine>
            <ReferenceArea
              x1={refF2.days}
              x2={refF2.days}
              y1={0}
              y2={refF2.score || refF2.score_2}
              fill="red"
              strokeWidth={2}
              fillOpacity={1}
              onClick={showDetailPopupCritical}
              cursor={"pointer"}
              stroke="#7067ac"
              label={<CustomLabelPurple value={"Functional Failure (F)"} />}
            ></ReferenceArea>
          </>
        ) : null}
        {refC ? (
          <>
            <ReferenceLine
              x={refC.days}
              stroke="#7067ac"
              strokeDasharray="3 3"
            ></ReferenceLine>
            <ReferenceLine
              y={refC.score}
              stroke="#7067ac"
              strokeDasharray="3 3"
            ></ReferenceLine>
            <ReferenceArea
              x1={refC.days}
              x2={refC.days}
              y1={0}
              y2={refC.score}
              fill="red"
              cursor={"pointer"}
              onClick={showCurrentCondition}
              strokeWidth={2}
              fillOpacity={1}
              stroke="#a1a1a1"
              label={<CustomLabelGrey value={"Current Condition"} />}
            ></ReferenceArea>
          </>
        ) : null}
      </AreaChart>
    </ResponsiveContainer>
  );
};
/* Todo data prop define */
export default ChartDegradationOverview;
